var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.FormContainer,{attrs:{"title":_vm.$t('showUserMessage')}},[_c(_setup.Form,{attrs:{"fetchingData":_setup.isFetching,"model":_setup.userModel,"readonly":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }